module.exports = __webpack_public_path__ + "img/client3.e96a4bd3.svg";